const styles = {
  login_stack: {
    pl: "10%",
    pr: "10%",
    pb: {
      xs: '50px',
      sm: '50px',
      md: '50px',
      lg: '30px',
      xl: '30px',
    },
    bgcolor: "white",
    margin: '0 auto',
    boxShadow: 1,
    borderRadius: "16px",
    pt: {
      xs: '40px',
      sm: '40px',
      md: '50px',
      lg: '60px',
      xl: '60px',
    },
    width: {
      xs: '98%',
      sm: '98%',
      md: '60%',
      lg: '50%',
      xl: '55%',
    },
  },
  t_signin: { 
    fontSize: {
      xs: 20,
      sm: 20,
      md: 20,
      lg: 24,
      xl: 24,
    }, 
    fontFamily: "Inter",
    color: 'black' 
  },
  t_description: {  
    fontSize: {
      xs: 13,
      sm: 13,
      md: 13,
      lg: 14,
      xl: 14,
    }, 
    fontFamily: "Inter",
    fontWeight: "700", 
    color: '#64748B' 
  },
}

export default styles;